export default __webpack_public_path__ + "static/char-s-08-jp-7ddd187b48cae7fa391f8a7953e89684.png";